import { render, staticRenderFns } from "./month-table.vue?vue&type=template&id=24afba27"
import script from "./month-table.vue?vue&type=script&lang=js"
export * from "./month-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports